{
    "addFromLibrary": "Lägg till från bibliotek",
    "uploadFile": "Ladda upp PDF-fil",
    "name": "Namn",
    "description": "Beskrivning",
    "actions": "handlingar",
    "attachmentLibrary": "Bilagebibliotek",
    "search": "Sök",
    "preview": "Förhandsgranska",
    "back": "Tillbaka",
    "save": "Spara",
    "moveDown": "Flytta ner",
    "moveUp": "Flytta upp",
    "delete": "Radera",
    "unselectAllAttachments": "Avmarkera alla bilagor",
    "selectAllAttachments": "Välj alla bilagor",
    "unselectAttachment": "Avmarkera bilaga",
    "selectAttachment": "Välj bilaga",
    "previewAttachment": "Förhandsgranska bilaga"
}